import React, { useCallback, useState } from 'react'
import { useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import DeleteIntegrationModal from '../../../../../components/Modals/DeleteIntegrationModal';
import PageErrorModal from '../../../../../components/Modals/PageErrorModal';
import PauseIntegrationModal from '../../../../../components/Modals/PauseIntegrationModal';
import PreviousLeadsModal from '../../../../../components/Modals/PreviousLeadsModal'
import { createDatewithTime } from '../../../../../helpers/date';
import { deleteIntergration, getErrorInfo, getInetgrationsPageForms, getUnprocessedLeads, importPreviousLeads, resolveError, updateActiveState, updatePageActiveState } from '../../../../../services/private/company.service';
import { Oval } from 'react-loader-spinner';
import { ReactComponent as BackCircle } from '../../../../../assets/icons/backCircle.svg';
import { ReactComponent as Pageback } from '../../../../../assets/icons/Pageback.svg';

const PageLinkForms = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [openErrorModal, setOpenErrorModal] = useState(false);
  const [pageForms, setPageForms] = useState();
  const [dateRange, setDateRange] = useState();
  const [ignoreDuplicate, setIgnoreDuplicate] = useState(true);
  const [errorLeadsList, setErrorLeadsList] = useState([]);
  const [selectedForm, setSelectedForm] = useState();
  const [errorInfo, setErrorInfo] = useState();
  const [intergrationPause, setIntergrationPause] = useState(false);
  const [intergrationToPause, setIntergrationToPause] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const { id } = useParams();
  const location = useLocation();
  const history = useHistory();

  const getPageLinkForm = useCallback(() => {
    getInetgrationsPageForms(id).then(res => {
      if (res.data.status === 200) {
        setPageForms(res.data.data);
      }
    }).catch(err => {
      console.log(err)
    })
  }, [])

  const handleGetErrorInfo = (form) => {
    setSelectedForm(form);
    getErrorInfo(form.id || form.form_id).then(res => {
      if (res.data.status === 200) {
        setErrorInfo(res.data.data);
        setOpenErrorModal(true);
      }
    }).catch(err => {
      console.log({ err })
    })
  }

  useEffect(() => {
    if (id) getPageLinkForm();
  }, [id])

  const handleDateRange = useCallback((date) => {
    setDateRange(date)
  }, []);

  const hndleDuplicateIgnore = useCallback((val) => {
    setIgnoreDuplicate(val)
  }, []);

  const getPreviousLeads = useCallback(() => {
    if (dateRange) {
      const payload = {
        from: dateRange.from,
        to: dateRange.to,
        ignore_duplicate: ignoreDuplicate
      }
      importPreviousLeads(id, payload).then(res => {
        console.log({ res })
        closeModal();
      }).catch(err => {
        console.log({ err })
        closeModal();
      })
    }
  }, [dateRange]);


  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  const closeSideModal = useCallback(() => {
    setOpenErrorModal(false);
  }, []);

  const handleImportPreviousLead = (formId) => {
    localStorage.setItem('formId', formId);

    history.push({
      pathname: `/settings/integrations/all-integrations/facebook-forms/page-link-form/${id}/import-previous`,
      state: { pageName: location.state.pageName }
    })
  }

  const handlePauseIntegration = useCallback((index, status, uuid) => {
    setIntergrationToPause({
      index, status, uuid
    })
    setIntergrationPause(true);
  }, []);

  const closeIntergrationPauseModal = useCallback(() => {
    setIntergrationPause(false)
  }, [])

  const handleStatusChange = useCallback((index, status, uuid) => {
    intergrationPause && closeIntergrationPauseModal();
    setIsLoading(true)
    setIntergrationToPause({
      index, status, uuid
    })
    updatePageActiveState(uuid, { status }).then(res => {
      if (res.data.status) {
        getPageLinkForm();
        setIsLoading(false);
        toast.success(`Intergration  ${status === 'ACTIVE' ? 'Active' : 'Paused'}`)
      }
    }).catch(err => {
      console.log({ err })
      setIsLoading(false);
    })
  }, [pageForms, intergrationPause]);

  const renderTableValue = (form, index) => {
    let dbForm = pageForms.forms.find(item => item.form_id === form.id);
    return (
      <tr key={`${index}_${form.id}`} className={`${location.state.pageStatus != 'ACTIVE' ? 'old-leads' : ''}`}>
        <td >{index + 1}</td>
        <td>
          {(form.name || form.form_name).length > 20 ?
            <OverlayTrigger
              placement="auto"
              overlay={
                <Tooltip id="button-tooltip" >
                  <div className='info-msg'>
                    {/* <h4>Total Leads</h4> */}
                    <p className=''>{form.name || form.form_name}</p>
                  </div>
                </Tooltip>
              }
            >
              <span className='three-dots'>{form.name || form.form_name}</span>
            </OverlayTrigger>
            :
            <span className=''>{form.name || form.form_name}</span>
          }
          {dbForm?.is_error &&
            <span onClick={() => handleGetErrorInfo(form)} className='cursor-pointer ml-2'>
              <svg width="22" height="20" viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect width="18" height="18" transform="translate(2)" fill="white" />
                <path d="M10.1453 2.15002C10.539 1.53808 11.4336 1.53808 11.8273 2.15002L19.7377 14.446C20.1658 15.1115 19.688 15.987 18.8967 15.987H3.07594C2.28462 15.987 1.80681 15.1115 2.23495 14.446L10.1453 2.15002Z" fill="#FBBC05" stroke="#FBBC05" strokeWidth="2.26374" strokeLinejoin="round" />
                <path d="M10.25 6.15V10.65C10.25 11.1471 10.6529 11.55 11.15 11.55C11.6471 11.55 12.05 11.1471 12.05 10.65V6.15C12.05 5.65294 11.6471 5.25 11.15 5.25C10.6529 5.25 10.25 5.65294 10.25 6.15Z" fill="white" />
                <path d="M12.05 13.35C12.05 13.8471 11.6471 14.25 11.15 14.25C10.6529 14.25 10.25 13.8471 10.25 13.35C10.25 12.8529 10.6529 12.45 11.15 12.45C11.6471 12.45 12.05 12.8529 12.05 13.35Z" fill="white" />
              </svg>

            </span>
          }
        </td>
        <td>
          {(form.id || form.form_id).length > 20 ?
            <OverlayTrigger
              placement="auto"
              overlay={
                <Tooltip id="button-tooltip" >
                  <div className='info-msg'>
                    {/* <h4>Total Leads</h4> */}
                    <p className=''>{form.id || form.form_id}</p>
                  </div>
                </Tooltip>
              }
            >
              <span className='three-dots'>{form.id || form.form_id}</span>
            </OverlayTrigger>
            :
            <span className=''>{form.id || form.form_id}</span>
          }
        </td>
        <td>
          {dbForm?.project_name.length > 20 ?
            <OverlayTrigger
              placement="auto"
              overlay={
                <Tooltip id="button-tooltip" >
                  <div className='info-msg'>
                    {/* <h4>Total Leads</h4> */}
                    <p className=''>{dbForm?.project_name}</p>
                  </div>
                </Tooltip>
              }
            >
              <span className='three-dots'>{dbForm?.project_name}</span>
            </OverlayTrigger>
            :
            <span className=''>{dbForm?.project_name || '-'}</span>
          }

        </td>
        <td>{dbForm?.total_leads || '-'}</td>
        <td>
          <button
            className={`${dbForm ? dbForm?.status === 'ACTIVE' ? 'hot-btn' : 'dead-btn' : 'warm-btn'} fz14 fw-po-medim w-100px remove-hover d-flex justify-content-center`}
            style={{ cursor: 'auto' }}
            disabled={isLoading && (intergrationToPause && intergrationToPause?.index === index)}
          >
            {(isLoading && (intergrationToPause && intergrationToPause?.index === index)) ?
              <Oval
                height={18}
                width={40}
                color="#FFFFFF"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
                ariaLabel='oval-loading'
                secondaryColor="#FFFFFF"
                strokeWidth={4}
                strokeWidthSecondary={4}
              />
              :
              dbForm?.status ? dbForm?.status === 'ACTIVE' ? 'Active' : 'Paused' : 'In-Active'
            }
          </button>
        </td>
        <td>{dbForm && dbForm?.last_lead_received_date ? createDatewithTime(new Date(dbForm?.last_lead_received_date)) : '-'}	</td>
        <td className='file-name'>
          {dbForm?.created_by.length > 10 ?
            <OverlayTrigger
              placement="auto"
              overlay={
                <Tooltip id="button-tooltip" >
                  <div className='info-msg'>
                    {/* <h4>Total Leads</h4> */}
                    <p className=''>{(dbForm && dbForm?.created_by)}</p>
                  </div>
                </Tooltip>
              }
            >
              <span className='three-dots'>{(dbForm && dbForm?.created_by)}</span>
            </OverlayTrigger>
            :
            <span className=''> {(dbForm && dbForm?.created_by) || '-'}</span>
          }
        </td>
        <td>{dbForm && dbForm?.created_on ? createDatewithTime(new Date(dbForm?.created_on)) : '-'}	</td>
        <td className='dropdown view-more'>
          {
            dbForm && location.state.pageStatus === 'ACTIVE' && <>
              <button className="btn" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path fillRule="evenodd" clipRule="evenodd" d="M12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19C14 17.8954 13.1046 17 12 17Z" fill="#B5B5BE"></path><path fillRule="evenodd" clipRule="evenodd" d="M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10Z" fill="#B5B5BE"></path><path fillRule="evenodd" clipRule="evenodd" d="M12 3C10.8954 3 10 3.89543 10 5C10 6.10457 10.8954 7 12 7C13.1046 7 14 6.10457 14 5C14 3.89543 13.1046 3 12 3Z" fill="#B5B5BE"></path></svg>
              </button>
              <div className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                <a className="dropdown-item" onClick={() => handleImportPreviousLead(form.id)}>Import previous leads</a>
                <a
                  className="dropdown-item"
                  onClick={() => {
                    if (dbForm && dbForm?.status === 'ACTIVE') {
                      handlePauseIntegration(index, 'PAUSED', dbForm.uuid)
                    } else {
                      handleStatusChange(index, 'ACTIVE', dbForm.uuid)
                    }
                  }}
                >{dbForm && dbForm?.status === 'ACTIVE' ? 'Pause' : 'Resume'} Integration</a>
                {/* <a className="dropdown-item del-menu-itme" onClick={() => showDeleteIntergationModal(form)} >Delete</a> */}
              </div>
            </>}
        </td>
      </tr >
    )
  }

  return (
    <>
      <div className="w-100 fbintegration flex flex-col h-full ">
        <div className="settings-title">
          <div className="row">
            <div className="col-12">
              <nav aria-label="breadcrumb" className='inner-page-breadcrumb'>
                <ul className="d-flex align-items-center justify-content-start flex-row mb4">
                  <li>
                    <Link to='/settings/integrations/all-integrations'>All Integration</Link>
                  </li>
                  <li className='flex items-center'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                    <path d="M4 3.5L8.5 8L4 12.5" stroke="#696974" />
                  </svg>
                    <Link to='/settings/integrations/all-integrations/facebook-forms'>Facebook Integration</Link>
                  </li>
                  <li className='flex items-center'><svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16" fill="none">
                    <path d="M4 3.5L8.5 8L4 12.5" stroke="#696974" />
                  </svg> {location.state.pageName}</li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="row">
            <div className="col-xl-5 col-lg-8 col-md-8 col-sm-6 col-12">
              <h1 className='fz24 black mb-0 fw-po-medium ls5 flex items-center !gap-x-2'>
                <Link

                  to='/settings/integrations/all-integrations/facebook-forms'
                  className="w-8 h-8 hover:bg-black200 rounded inline-flex items-center justify-center titlebackbtn"
                >
                  <Pageback className="group-hover:stroke-black" />
                </Link>

                {location.state.pageName}
              </h1>
              {/* <p className='fz16 black-dark-700 ls5 mb-0'><span className='fw-po-medium black-dark-800'>{pageForms && pageForms.forms.length} Forms</span> Connected from this page.</p> */}
            </div>
            <div className="col-xl-7 col-lg-4 col-md-4 col-sm-6 col-12 d-flex justify-content-sm-end align-items-end mt-sm-0 mt-3">

              <Link to={{ pathname: `/settings/integrations/all-integrations/facebook-forms/page-link-form/${id}/import-previous`, state: { pageName: location.state.pageName } }} className="pr-btn px-16 d-inline-flex align-items-center">
                <svg className="mr4 d-xl-inline-block d-none" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><mask id="path-1-inside-1_1117_451" fill="white"><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z"></path></mask><path fillRule="evenodd" clipRule="evenodd" d="M12.6665 11.3335H17.3331C17.7013 11.3335 17.9998 11.6319 17.9998 12.0001C17.9998 12.3683 17.7013 12.6668 17.3331 12.6668H12.6665V17.3333C12.6665 17.7015 12.3681 18 11.9999 18C11.6317 18 11.3332 17.7015 11.3332 17.3333V12.6668H6.66665C6.29847 12.6668 6 12.3683 6 12.0001C6 11.6319 6.29847 11.3335 6.66665 11.3335H11.3332V6.6669C11.3332 6.29871 11.6317 6.00024 11.9999 6.00024C12.3681 6.00024 12.6665 6.29871 12.6665 6.6669V11.3335Z" fill="white"></path><path d="M12.6665 11.3335H9.66653V14.3335H12.6665V11.3335ZM12.6665 12.6668V9.66678H9.66653V12.6668H12.6665ZM11.3332 12.6668H14.3332V9.66678H11.3332V12.6668ZM11.3332 11.3335V14.3335H14.3332V11.3335H11.3332ZM12.6665 14.3335H17.3331V8.33347H12.6665V14.3335ZM17.3331 14.3335C16.0444 14.3335 14.9998 13.2888 14.9998 12.0001H20.9998C20.9998 9.97509 19.3581 8.33347 17.3331 8.33347V14.3335ZM14.9998 12.0001C14.9998 10.7115 16.0444 9.66678 17.3331 9.66678V15.6668C19.3581 15.6668 20.9998 14.0252 20.9998 12.0001H14.9998ZM17.3331 9.66678H12.6665V15.6668H17.3331V9.66678ZM9.66653 12.6668V17.3333H15.6665V12.6668H9.66653ZM9.66653 17.3333C9.66653 16.0447 10.7112 15 11.9999 15V21C14.0249 21 15.6665 19.3584 15.6665 17.3333H9.66653ZM11.9999 15C13.2885 15 14.3332 16.0447 14.3332 17.3333H8.33322C8.33322 19.3584 9.97484 21 11.9999 21V15ZM14.3332 17.3333V12.6668H8.33322V17.3333H14.3332ZM11.3332 9.66678H6.66665V15.6668H11.3332V9.66678ZM6.66665 9.66678C7.95533 9.66678 9 10.7115 9 12.0001H3C3 14.0252 4.64162 15.6668 6.66665 15.6668V9.66678ZM9 12.0001C9 13.2888 7.95533 14.3335 6.66665 14.3335V8.33347C4.64162 8.33347 3 9.97509 3 12.0001H9ZM6.66665 14.3335H11.3332V8.33347H6.66665V14.3335ZM14.3332 11.3335V6.6669H8.33322V11.3335H14.3332ZM14.3332 6.6669C14.3332 7.95557 13.2885 9.00024 11.9999 9.00024V3.00024C9.97484 3.00024 8.33322 4.64186 8.33322 6.6669H14.3332ZM11.9999 9.00024C10.7112 9.00024 9.66653 7.95557 9.66653 6.6669H15.6665C15.6665 4.64186 14.0249 3.00024 11.9999 3.00024V9.00024ZM9.66653 6.6669V11.3335H15.6665V6.6669H9.66653Z" fill="white" mask="url(#path-1-inside-1_1117_451)"></path></svg>Import Old Leads
              </Link>

            </div>
          </div>
        </div>

        <div className="fb-innerpageintegratoin h-full overflow-auto mt-24 ml-24 ">
          <div className="def-table pr-24 pl-0 !h-full">
            <table className='table mb-0'>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Form Name</th>
                  <th>Form ID</th>
                  <th>Project</th>
                  <th>Total Leads</th>
                  <th>Status</th>
                  <th>Last Lead Received</th>
                  <th>Created By</th>
                  <th>Date Created</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {pageForms && pageForms.facebookForms?.data.map((form, index) => (
                  renderTableValue(form, index)
                ))}
              </tbody>
            </table>
          </div>
        </div>


      </div >
      {
        showModal && <PreviousLeadsModal
          showModal={showModal}
          closeModal={closeModal}
          handleDateRange={handleDateRange}
          getPreviousLeads={getPreviousLeads}
          ignoreDuplicate={ignoreDuplicate}
          hndleDuplicateIgnore={hndleDuplicateIgnore}
        />
      }
      {
        openErrorModal &&
        <PageErrorModal
          showSideModal={openErrorModal}
          closeSideModal={closeSideModal}
          pageName={location.state.pageName}
          form={selectedForm}
          errorInfo={errorInfo}
        />
      }
      {intergrationPause && <PauseIntegrationModal
        show={intergrationPause}
        closeModal={closeIntergrationPauseModal}
        handleStatusChange={handleStatusChange}
        intergrationToPause={intergrationToPause}
      />}
    </>
  )
}

export default PageLinkForms